import { useState, useEffect } from 'react';
import { ProductVerification } from '../types';
import raydelImg from '../assets/products/raydel.png';
import titanicImage from '../assets/products/taitanic.png';

const MOCK_DATA: Record<string, ProductVerification> = {
  raydel: {
    isAuthentic: true,
    category: {
      name: 'INO MEDICAL',
      tag: '@ino_medical',
    },
    product: {
      type: '건강기능식품',
      name: '레이델',
      details: '폴리코사놀 20 1개월분',
      image: raydelImg,
    },
    connectUrl: 'https://raydel.co.kr/goods/goods_view.php?goodsNo=1000002080',
    buttonText: '판매 페이지로 이동',
  },
  taitanic: {
    isAuthentic: true,
    category: {
      name: 'INO GOODS',
      tag: '@ino_goods',
    },
    product: {
      type: '영화포스터',
      name: '타이타닉',
      details: '20th Century Fox',
      image: titanicImage,
    },
    connectUrl: 'https://www.youtube.com/watch?v=kVrqfYjkTdQ',
    buttonText: '예고편 보러가기',
  },
};

interface ProductDataState {
  product: ProductVerification | null;
  loading: boolean;
  error: Error | null;
}

export const useProductData = (productId: string | undefined) => {
  const [state, setState] = useState<ProductDataState>({
    product: null,
    loading: true,
    error: null,
  });

  useEffect(() => {
    if (!productId) {
      setState({
        product: null,
        loading: false,
        error: new Error('제품 ID가 없습니다'),
      });
      return;
    }

    setState((prev) => ({ ...prev, loading: true }));

    setTimeout(() => {
      const productData = MOCK_DATA[productId];

      if (productData) {
        setState({
          product: productData,
          loading: false,
          error: null,
        });
      } else {
        setState({
          product: null,
          loading: false,
          error: new Error('제품을 찾을 수 없습니다'),
        });
      }
    }, 300);
  }, [productId]);

  return state;
};
